
/* eslint-disable */
import { languageTag } from "./runtime.js"
import * as en_AU from "./messages/en-AU.js"
import * as en_US from "./messages/en-US.js"
import * as fr from "./messages/fr.js"
import * as it from "./messages/it.js"

/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-US" | "en-AU" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const about = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.about,
		"en-US": en_US.about,
		fr: fr.about,
		it: it.about
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const acceptance = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.acceptance,
		"en-US": en_US.acceptance,
		fr: fr.acceptance,
		it: it.acceptance
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement,
		"en-US": en_US.achievement,
		fr: fr.achievement,
		it: it.achievement
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ name: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementImageAltText = (params , options = {}) => {
	return {
		"en-AU": en_AU.achievementImageAltText,
		"en-US": en_US.achievementImageAltText,
		fr: fr.achievementImageAltText,
		it: it.achievementImageAltText
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardAnotherCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_awardAnotherCTA,
		"en-US": en_US.achievement_awardAnotherCTA,
		fr: fr.achievement_awardAnotherCTA,
		it: it.achievement_awardAnotherCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardCountSummary = (params , options = {}) => {
	return {
		"en-AU": en_AU.achievement_awardCountSummary,
		"en-US": en_US.achievement_awardCountSummary,
		fr: fr.achievement_awardCountSummary,
		it: it.achievement_awardCountSummary
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_heading = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_badgesClaimed_heading,
		"en-US": en_US.achievement_badgesClaimed_heading,
		fr: fr.achievement_badgesClaimed_heading,
		it: it.achievement_badgesClaimed_heading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_loginCTA_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_badgesClaimed_loginCTA_description,
		"en-US": en_US.achievement_badgesClaimed_loginCTA_description,
		fr: fr.achievement_badgesClaimed_loginCTA_description,
		it: it.achievement_badgesClaimed_loginCTA_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_noneAvailable = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_badgesClaimed_noneAvailable,
		"en-US": en_US.achievement_badgesClaimed_noneAvailable,
		fr: fr.achievement_badgesClaimed_noneAvailable,
		it: it.achievement_badgesClaimed_noneAvailable
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_claimCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_claimCTA,
		"en-US": en_US.achievement_claimCTA,
		fr: fr.achievement_claimCTA,
		it: it.achievement_claimCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_claimCountSummary = (params , options = {}) => {
	return {
		"en-AU": en_AU.achievement_claimCountSummary,
		"en-US": en_US.achievement_claimCountSummary,
		fr: fr.achievement_claimCountSummary,
		it: it.achievement_claimCountSummary
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_createNewDescription = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_createNewDescription,
		"en-US": en_US.achievement_createNewDescription,
		fr: fr.achievement_createNewDescription,
		it: it.achievement_createNewDescription
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_createNewHeading = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_createNewHeading,
		"en-US": en_US.achievement_createNewHeading,
		fr: fr.achievement_createNewHeading,
		it: it.achievement_createNewHeading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_deleteConfirm_description = (params , options = {}) => {
	return {
		"en-AU": en_AU.achievement_deleteConfirm_description,
		"en-US": en_US.achievement_deleteConfirm_description,
		fr: fr.achievement_deleteConfirm_description,
		it: it.achievement_deleteConfirm_description
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_deleteConfirm_heading = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_deleteConfirm_heading,
		"en-US": en_US.achievement_deleteConfirm_heading,
		fr: fr.achievement_deleteConfirm_heading,
		it: it.achievement_deleteConfirm_heading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_editCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_editCTA,
		"en-US": en_US.achievement_editCTA,
		fr: fr.achievement_editCTA,
		it: it.achievement_editCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_edit_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_edit_description,
		"en-US": en_US.achievement_edit_description,
		fr: fr.achievement_edit_description,
		it: it.achievement_edit_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown>, timeAgo: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_invitedByNameAtTime = (params , options = {}) => {
	return {
		"en-AU": en_AU.achievement_invitedByNameAtTime,
		"en-US": en_US.achievement_invitedByNameAtTime,
		fr: fr.achievement_invitedByNameAtTime,
		it: it.achievement_invitedByNameAtTime
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_name = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_name,
		"en-US": en_US.achievement_name,
		fr: fr.achievement_name,
		it: it.achievement_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_narrative = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_narrative,
		"en-US": en_US.achievement_narrative,
		fr: fr.achievement_narrative,
		it: it.achievement_narrative
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_openClaimable_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_openClaimable_description,
		"en-US": en_US.achievement_openClaimable_description,
		fr: fr.achievement_openClaimable_description,
		it: it.achievement_openClaimable_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_other = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_other,
		"en-US": en_US.achievement_other,
		fr: fr.achievement_other,
		it: it.achievement_other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_share_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_share_description,
		"en-US": en_US.achievement_share_description,
		fr: fr.achievement_share_description,
		it: it.achievement_share_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_youHaveClaimed_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_youHaveClaimed_description,
		"en-US": en_US.achievement_youHaveClaimed_description,
		fr: fr.achievement_youHaveClaimed_description,
		it: it.achievement_youHaveClaimed_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_all = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievements_all,
		"en-US": en_US.achievements_all,
		fr: fr.achievements_all,
		it: it.achievements_all
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievements_description,
		"en-US": en_US.achievements_description,
		fr: fr.achievements_description,
		it: it.achievements_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action_other = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.action_other,
		"en-US": en_US.action_other,
		fr: fr.action_other,
		it: it.action_other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const adminRoleLabel = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.adminRoleLabel,
		"en-US": en_US.adminRoleLabel,
		fr: fr.adminRoleLabel,
		it: it.adminRoleLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardBadgeCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.awardBadgeCTA,
		"en-US": en_US.awardBadgeCTA,
		fr: fr.awardBadgeCTA,
		it: it.awardBadgeCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardBadgeCTA_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.awardBadgeCTA_description,
		"en-US": en_US.awardBadgeCTA_description,
		fr: fr.awardBadgeCTA_description,
		it: it.awardBadgeCTA_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.awardCTA,
		"en-US": en_US.awardCTA,
		fr: fr.awardCTA,
		it: it.awardCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_createUserIfNotExistsOption = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.award_createUserIfNotExistsOption,
		"en-US": en_US.award_createUserIfNotExistsOption,
		fr: fr.award_createUserIfNotExistsOption,
		it: it.award_createUserIfNotExistsOption
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_narrative_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.award_narrative_description,
		"en-US": en_US.award_narrative_description,
		fr: fr.award_narrative_description,
		it: it.award_narrative_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_narrative_placeholder = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.award_narrative_placeholder,
		"en-US": en_US.award_narrative_placeholder,
		fr: fr.award_narrative_placeholder,
		it: it.award_narrative_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_noneYet = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.award_noneYet,
		"en-US": en_US.award_noneYet,
		fr: fr.award_noneYet,
		it: it.award_noneYet
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_recipientEmail = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.award_recipientEmail,
		"en-US": en_US.award_recipientEmail,
		fr: fr.award_recipientEmail,
		it: it.award_recipientEmail
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardedBadge = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.awardedBadge,
		"en-US": en_US.awardedBadge,
		fr: fr.awardedBadge,
		it: it.awardedBadge
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ achievementName: NonNullable<unknown>, communityName: NonNullable<unknown>, badgeUrl: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardedBadge_email_description = (params , options = {}) => {
	return {
		"en-AU": en_AU.awardedBadge_email_description,
		"en-US": en_US.awardedBadge_email_description,
		fr: fr.awardedBadge_email_description,
		it: it.awardedBadge_email_description
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.backpack,
		"en-US": en_US.backpack,
		fr: fr.backpack,
		it: it.backpack
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_emptyStateCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.backpack_emptyStateCTA,
		"en-US": en_US.backpack_emptyStateCTA,
		fr: fr.backpack_emptyStateCTA,
		it: it.backpack_emptyStateCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_emptyState_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.backpack_emptyState_description,
		"en-US": en_US.backpack_emptyState_description,
		fr: fr.backpack_emptyState_description,
		it: it.backpack_emptyState_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadge = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.backpack_yourBadge,
		"en-US": en_US.backpack_yourBadge,
		fr: fr.backpack_yourBadge,
		it: it.backpack_yourBadge
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadges_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.backpack_yourBadges_description,
		"en-US": en_US.backpack_yourBadges_description,
		fr: fr.backpack_yourBadges_description,
		it: it.backpack_yourBadges_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadges_heading = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.backpack_yourBadges_heading,
		"en-US": en_US.backpack_yourBadges_heading,
		fr: fr.backpack_yourBadges_heading,
		it: it.backpack_yourBadges_heading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const badge_one = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.badge_one,
		"en-US": en_US.badge_one,
		fr: fr.badge_one,
		it: it.badge_one
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const badge_other = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.badge_other,
		"en-US": en_US.badge_other,
		fr: fr.badge_other,
		it: it.badge_other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumb = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.breadcrumb,
		"en-US": en_US.breadcrumb,
		fr: fr.breadcrumb,
		it: it.breadcrumb
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const cancelCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.cancelCTA,
		"en-US": en_US.cancelCTA,
		fr: fr.cancelCTA,
		it: it.cancelCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.categories_description,
		"en-US": en_US.categories_description,
		fr: fr.categories_description,
		it: it.categories_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_editCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.categories_editCTA,
		"en-US": en_US.categories_editCTA,
		fr: fr.categories_editCTA,
		it: it.categories_editCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_title = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.categories_title,
		"en-US": en_US.categories_title,
		fr: fr.categories_title,
		it: it.categories_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.category,
		"en-US": en_US.category,
		fr: fr.category,
		it: it.category
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_achievementCount = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.category_achievementCount,
		"en-US": en_US.category_achievementCount,
		fr: fr.category_achievementCount,
		it: it.category_achievementCount
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_name = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.category_name,
		"en-US": en_US.category_name,
		fr: fr.category_name,
		it: it.category_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_other = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.category_other,
		"en-US": en_US.category_other,
		fr: fr.category_other,
		it: it.category_other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_weight = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.category_weight,
		"en-US": en_US.category_weight,
		fr: fr.category_weight,
		it: it.category_weight
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_cancelFailError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.chapi_cancelFailError,
		"en-US": en_US.chapi_cancelFailError,
		fr: fr.chapi_cancelFailError,
		it: it.chapi_cancelFailError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.chapi_description,
		"en-US": en_US.chapi_description,
		fr: fr.chapi_description,
		it: it.chapi_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_noPolyfillError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.chapi_noPolyfillError,
		"en-US": en_US.chapi_noPolyfillError,
		fr: fr.chapi_noPolyfillError,
		it: it.chapi_noPolyfillError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_walletSignupCTA_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.chapi_walletSignupCTA_description,
		"en-US": en_US.chapi_walletSignupCTA_description,
		fr: fr.chapi_walletSignupCTA_description,
		it: it.chapi_walletSignupCTA_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimCTA,
		"en-US": en_US.claimCTA,
		fr: fr.claimCTA,
		it: it.claimCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_adminOnly_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_adminOnly_description,
		"en-US": en_US.claimConfiguration_adminOnly_description,
		fr: fr.claimConfiguration_adminOnly_description,
		it: it.claimConfiguration_adminOnly_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_allow = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_allow,
		"en-US": en_US.claimConfiguration_allow,
		fr: fr.claimConfiguration_allow,
		it: it.claimConfiguration_allow
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimDisabled = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_claimDisabled,
		"en-US": en_US.claimConfiguration_claimDisabled,
		fr: fr.claimConfiguration_claimDisabled,
		it: it.claimConfiguration_claimDisabled
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimEnabled = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_claimEnabled,
		"en-US": en_US.claimConfiguration_claimEnabled,
		fr: fr.claimConfiguration_claimEnabled,
		it: it.claimConfiguration_claimEnabled
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimRequiresSummary = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_claimRequiresSummary,
		"en-US": en_US.claimConfiguration_claimRequiresSummary,
		fr: fr.claimConfiguration_claimRequiresSummary,
		it: it.claimConfiguration_claimRequiresSummary
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_heading = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_heading,
		"en-US": en_US.claimConfiguration_heading,
		fr: fr.claimConfiguration_heading,
		it: it.claimConfiguration_heading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_noReviewsRequired_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_noReviewsRequired_description,
		"en-US": en_US.claimConfiguration_noReviewsRequired_description,
		fr: fr.claimConfiguration_noReviewsRequired_description,
		it: it.claimConfiguration_noReviewsRequired_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_openClaimableCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_openClaimableCTA,
		"en-US": en_US.claimConfiguration_openClaimableCTA,
		fr: fr.claimConfiguration_openClaimableCTA,
		it: it.claimConfiguration_openClaimableCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_relatedAchievementNotFoundError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_relatedAchievementNotFoundError,
		"en-US": en_US.claimConfiguration_relatedAchievementNotFoundError,
		fr: fr.claimConfiguration_relatedAchievementNotFoundError,
		it: it.claimConfiguration_relatedAchievementNotFoundError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_requiredAchievement = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_requiredAchievement,
		"en-US": en_US.claimConfiguration_requiredAchievement,
		fr: fr.claimConfiguration_requiredAchievement,
		it: it.claimConfiguration_requiredAchievement
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_requiredAchievement_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_requiredAchievement_description,
		"en-US": en_US.claimConfiguration_requiredAchievement_description,
		fr: fr.claimConfiguration_requiredAchievement_description,
		it: it.claimConfiguration_requiredAchievement_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewRequires = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_reviewRequires,
		"en-US": en_US.claimConfiguration_reviewRequires,
		fr: fr.claimConfiguration_reviewRequires,
		it: it.claimConfiguration_reviewRequires
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewRequires_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_reviewRequires_description,
		"en-US": en_US.claimConfiguration_reviewRequires_description,
		fr: fr.claimConfiguration_reviewRequires_description,
		it: it.claimConfiguration_reviewRequires_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequired = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_reviewsRequired,
		"en-US": en_US.claimConfiguration_reviewsRequired,
		fr: fr.claimConfiguration_reviewsRequired,
		it: it.claimConfiguration_reviewsRequired
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ reviewsRequired: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequiredSummary = (params , options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_reviewsRequiredSummary,
		"en-US": en_US.claimConfiguration_reviewsRequiredSummary,
		fr: fr.claimConfiguration_reviewsRequiredSummary,
		it: it.claimConfiguration_reviewsRequiredSummary
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequired_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_reviewsRequired_description,
		"en-US": en_US.claimConfiguration_reviewsRequired_description,
		fr: fr.claimConfiguration_reviewsRequired_description,
		it: it.claimConfiguration_reviewsRequired_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_unexpectedSaveError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_unexpectedSaveError,
		"en-US": en_US.claimConfiguration_unexpectedSaveError,
		fr: fr.claimConfiguration_unexpectedSaveError,
		it: it.claimConfiguration_unexpectedSaveError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userMeetsRequirement = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_userMeetsRequirement,
		"en-US": en_US.claimConfiguration_userMeetsRequirement,
		fr: fr.claimConfiguration_userMeetsRequirement,
		it: it.claimConfiguration_userMeetsRequirement
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userNotMeetRequirement_heading = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_userNotMeetRequirement_heading,
		"en-US": en_US.claimConfiguration_userNotMeetRequirement_heading,
		fr: fr.claimConfiguration_userNotMeetRequirement_heading,
		it: it.claimConfiguration_userNotMeetRequirement_heading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userNotMeetsRequirement = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_userNotMeetsRequirement,
		"en-US": en_US.claimConfiguration_userNotMeetsRequirement,
		fr: fr.claimConfiguration_userNotMeetsRequirement,
		it: it.claimConfiguration_userNotMeetsRequirement
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrativeInstructions = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimForm_narrativeInstructions,
		"en-US": en_US.claimForm_narrativeInstructions,
		fr: fr.claimForm_narrativeInstructions,
		it: it.claimForm_narrativeInstructions
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrative_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimForm_narrative_description,
		"en-US": en_US.claimForm_narrative_description,
		fr: fr.claimForm_narrative_description,
		it: it.claimForm_narrative_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrative_placeholder = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimForm_narrative_placeholder,
		"en-US": en_US.claimForm_narrative_placeholder,
		fr: fr.claimForm_narrative_placeholder,
		it: it.claimForm_narrative_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_achievementNotClaimableError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_achievementNotClaimableError,
		"en-US": en_US.claim_achievementNotClaimableError,
		fr: fr.claim_achievementNotClaimableError,
		it: it.claim_achievementNotClaimableError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_changeCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_changeCTA,
		"en-US": en_US.claim_changeCTA,
		fr: fr.claim_changeCTA,
		it: it.claim_changeCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_changeRejectedToAcceptedCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_changeRejectedToAcceptedCTA,
		"en-US": en_US.claim_changeRejectedToAcceptedCTA,
		fr: fr.claim_changeRejectedToAcceptedCTA,
		it: it.claim_changeRejectedToAcceptedCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_claimBadgeCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_claimBadgeCTA,
		"en-US": en_US.claim_claimBadgeCTA,
		fr: fr.claim_claimBadgeCTA,
		it: it.claim_claimBadgeCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_claimedByAnonMember = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_claimedByAnonMember,
		"en-US": en_US.claim_claimedByAnonMember,
		fr: fr.claim_claimedByAnonMember,
		it: it.claim_claimedByAnonMember
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_couldNotObtainInvitationError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_couldNotObtainInvitationError,
		"en-US": en_US.claim_couldNotObtainInvitationError,
		fr: fr.claim_couldNotObtainInvitationError,
		it: it.claim_couldNotObtainInvitationError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_editCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_editCTA,
		"en-US": en_US.claim_editCTA,
		fr: fr.claim_editCTA,
		it: it.claim_editCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_invitationEmailReconciliationError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_invitationEmailReconciliationError,
		"en-US": en_US.claim_invitationEmailReconciliationError,
		fr: fr.claim_invitationEmailReconciliationError,
		it: it.claim_invitationEmailReconciliationError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_invitationInvalidError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_invitationInvalidError,
		"en-US": en_US.claim_invitationInvalidError,
		fr: fr.claim_invitationInvalidError,
		it: it.claim_invitationInvalidError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_noExistingFoundError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_noExistingFoundError,
		"en-US": en_US.claim_noExistingFoundError,
		fr: fr.claim_noExistingFoundError,
		it: it.claim_noExistingFoundError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_notFoundError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_notFoundError,
		"en-US": en_US.claim_notFoundError,
		fr: fr.claim_notFoundError,
		it: it.claim_notFoundError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_notFoundOrNotShareableError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_notFoundOrNotShareableError,
		"en-US": en_US.claim_notFoundOrNotShareableError,
		fr: fr.claim_notFoundOrNotShareableError,
		it: it.claim_notFoundOrNotShareableError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_rejectCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_rejectCTA,
		"en-US": en_US.claim_rejectCTA,
		fr: fr.claim_rejectCTA,
		it: it.claim_rejectCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_sendToWalletCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_sendToWalletCTA,
		"en-US": en_US.claim_sendToWalletCTA,
		fr: fr.claim_sendToWalletCTA,
		it: it.claim_sendToWalletCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_shareCTA,
		"en-US": en_US.claim_shareCTA,
		fr: fr.claim_shareCTA,
		it: it.claim_shareCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ name: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareText_heading = (params , options = {}) => {
	return {
		"en-AU": en_AU.claim_shareText_heading,
		"en-US": en_US.claim_shareText_heading,
		fr: fr.claim_shareText_heading,
		it: it.claim_shareText_heading
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareUrlCopied = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_shareUrlCopied,
		"en-US": en_US.claim_shareUrlCopied,
		fr: fr.claim_shareUrlCopied,
		it: it.claim_shareUrlCopied
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusAccepted = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_statusAccepted,
		"en-US": en_US.claim_statusAccepted,
		fr: fr.claim_statusAccepted,
		it: it.claim_statusAccepted
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusAcceptedPublic = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_statusAcceptedPublic,
		"en-US": en_US.claim_statusAcceptedPublic,
		fr: fr.claim_statusAcceptedPublic,
		it: it.claim_statusAcceptedPublic
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvited = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_statusInvited,
		"en-US": en_US.claim_statusInvited,
		fr: fr.claim_statusInvited,
		it: it.claim_statusInvited
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ createdOn: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvitedFull_description = (params , options = {}) => {
	return {
		"en-AU": en_AU.claim_statusInvitedFull_description,
		"en-US": en_US.claim_statusInvitedFull_description,
		fr: fr.claim_statusInvitedFull_description,
		it: it.claim_statusInvitedFull_description
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvited_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_statusInvited_description,
		"en-US": en_US.claim_statusInvited_description,
		fr: fr.claim_statusInvited_description,
		it: it.claim_statusInvited_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejected = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_statusRejected,
		"en-US": en_US.claim_statusRejected,
		fr: fr.claim_statusRejected,
		it: it.claim_statusRejected
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejectedPublic_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_statusRejectedPublic_description,
		"en-US": en_US.claim_statusRejectedPublic_description,
		fr: fr.claim_statusRejectedPublic_description,
		it: it.claim_statusRejectedPublic_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejected_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_statusRejected_description,
		"en-US": en_US.claim_statusRejected_description,
		fr: fr.claim_statusRejected_description,
		it: it.claim_statusRejected_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUnacceptedPublic = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_statusUnacceptedPublic,
		"en-US": en_US.claim_statusUnacceptedPublic,
		fr: fr.claim_statusUnacceptedPublic,
		it: it.claim_statusUnacceptedPublic
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUserAccepted = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_statusUserAccepted,
		"en-US": en_US.claim_statusUserAccepted,
		fr: fr.claim_statusUserAccepted,
		it: it.claim_statusUserAccepted
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ createdOn: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUserAccepted_description = (params , options = {}) => {
	return {
		"en-AU": en_AU.claim_statusUserAccepted_description,
		"en-US": en_US.claim_statusUserAccepted_description,
		fr: fr.claim_statusUserAccepted_description,
		it: it.claim_statusUserAccepted_description
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusValidNoReviewRequired = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_statusValidNoReviewRequired,
		"en-US": en_US.claim_statusValidNoReviewRequired,
		fr: fr.claim_statusValidNoReviewRequired,
		it: it.claim_statusValidNoReviewRequired
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusValidSufficientReviews = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_statusValidSufficientReviews,
		"en-US": en_US.claim_statusValidSufficientReviews,
		fr: fr.claim_statusValidSufficientReviews,
		it: it.claim_statusValidSufficientReviews
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_unauthenticatedError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_unauthenticatedError,
		"en-US": en_US.claim_unauthenticatedError,
		fr: fr.claim_unauthenticatedError,
		it: it.claim_unauthenticatedError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_unauthenticatedUserEndorsementError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_unauthenticatedUserEndorsementError,
		"en-US": en_US.claim_unauthenticatedUserEndorsementError,
		fr: fr.claim_unauthenticatedUserEndorsementError,
		it: it.claim_unauthenticatedUserEndorsementError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_userNotMeetsPrerequsiteError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_userNotMeetsPrerequsiteError,
		"en-US": en_US.claim_userNotMeetsPrerequsiteError,
		fr: fr.claim_userNotMeetsPrerequsiteError,
		it: it.claim_userNotMeetsPrerequsiteError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_validFrom = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_validFrom,
		"en-US": en_US.claim_validFrom,
		fr: fr.claim_validFrom,
		it: it.claim_validFrom
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_validUntil = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_validUntil,
		"en-US": en_US.claim_validUntil,
		fr: fr.claim_validUntil,
		it: it.claim_validUntil
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_viewCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_viewCTA,
		"en-US": en_US.claim_viewCTA,
		fr: fr.claim_viewCTA,
		it: it.claim_viewCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_youHaveAwarded = (params , options = {}) => {
	return {
		"en-AU": en_AU.claim_youHaveAwarded,
		"en-US": en_US.claim_youHaveAwarded,
		fr: fr.claim_youHaveAwarded,
		it: it.claim_youHaveAwarded
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ inviteeEmail: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_youHaveInvited = (params , options = {}) => {
	return {
		"en-AU": en_AU.claim_youHaveInvited,
		"en-US": en_US.claim_youHaveInvited,
		fr: fr.claim_youHaveInvited,
		it: it.claim_youHaveInvited
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_yourPreferredEmail = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claim_yourPreferredEmail,
		"en-US": en_US.claim_yourPreferredEmail,
		fr: fr.claim_yourPreferredEmail,
		it: it.claim_yourPreferredEmail
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimed = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimed,
		"en-US": en_US.claimed,
		fr: fr.claimed,
		it: it.claimed
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const clipboard_couldNotCopyError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.clipboard_couldNotCopyError,
		"en-US": en_US.clipboard_couldNotCopyError,
		fr: fr.clipboard_couldNotCopyError,
		it: it.clipboard_couldNotCopyError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const close = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.close,
		"en-US": en_US.close,
		fr: fr.close,
		it: it.close
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const contactCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.contactCTA,
		"en-US": en_US.contactCTA,
		fr: fr.contactCTA,
		it: it.contactCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const contentMissing = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.contentMissing,
		"en-US": en_US.contentMissing,
		fr: fr.contentMissing,
		it: it.contentMissing
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const copyCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.copyCTA,
		"en-US": en_US.copyCTA,
		fr: fr.copyCTA,
		it: it.copyCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const createNewCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.createNewCTA,
		"en-US": en_US.createNewCTA,
		fr: fr.createNewCTA,
		it: it.createNewCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.criteria,
		"en-US": en_US.criteria,
		fr: fr.criteria,
		it: it.criteria
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.criteria_description,
		"en-US": en_US.criteria_description,
		fr: fr.criteria_description,
		it: it.criteria_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_placeholder = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.criteria_placeholder,
		"en-US": en_US.criteria_placeholder,
		fr: fr.criteria_placeholder,
		it: it.criteria_placeholder
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_url = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.criteria_url,
		"en-US": en_US.criteria_url,
		fr: fr.criteria_url,
		it: it.criteria_url
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.date,
		"en-US": en_US.date,
		fr: fr.date,
		it: it.date
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const deleteCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.deleteCTA,
		"en-US": en_US.deleteCTA,
		fr: fr.deleteCTA,
		it: it.deleteCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.description,
		"en-US": en_US.description,
		fr: fr.description,
		it: it.description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const downloadCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.downloadCTA,
		"en-US": en_US.downloadCTA,
		fr: fr.downloadCTA,
		it: it.downloadCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const earnedBadge = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.earnedBadge,
		"en-US": en_US.earnedBadge,
		fr: fr.earnedBadge,
		it: it.earnedBadge
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const editCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.editCTA,
		"en-US": en_US.editCTA,
		fr: fr.editCTA,
		it: it.editCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ message: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const email_transmissionError = (params , options = {}) => {
	return {
		"en-AU": en_AU.email_transmissionError,
		"en-US": en_US.email_transmissionError,
		fr: fr.email_transmissionError,
		it: it.email_transmissionError
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseFormCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.endorseFormCTA,
		"en-US": en_US.endorseFormCTA,
		fr: fr.endorseFormCTA,
		it: it.endorseFormCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_alreadyRecommendedError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.endorseForm_alreadyRecommendedError,
		"en-US": en_US.endorseForm_alreadyRecommendedError,
		fr: fr.endorseForm_alreadyRecommendedError,
		it: it.endorseForm_alreadyRecommendedError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_description = (params , options = {}) => {
	return {
		"en-AU": en_AU.endorseForm_description,
		"en-US": en_US.endorseForm_description,
		fr: fr.endorseForm_description,
		it: it.endorseForm_description
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_narrative_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.endorseForm_narrative_description,
		"en-US": en_US.endorseForm_narrative_description,
		fr: fr.endorseForm_narrative_description,
		it: it.endorseForm_narrative_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_addYoursCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.endorsement_addYoursCTA,
		"en-US": en_US.endorsement_addYoursCTA,
		fr: fr.endorsement_addYoursCTA,
		it: it.endorsement_addYoursCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_couldNotIdentifyEmailAddressError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.endorsement_couldNotIdentifyEmailAddressError,
		"en-US": en_US.endorsement_couldNotIdentifyEmailAddressError,
		fr: fr.endorsement_couldNotIdentifyEmailAddressError,
		it: it.endorsement_couldNotIdentifyEmailAddressError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_other = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.endorsement_other,
		"en-US": en_US.endorsement_other,
		fr: fr.endorsement_other,
		it: it.endorsement_other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_updateCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.endorsement_updateCTA,
		"en-US": en_US.endorsement_updateCTA,
		fr: fr.endorsement_updateCTA,
		it: it.endorsement_updateCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.error,
		"en-US": en_US.error,
		fr: fr.error,
		it: it.error
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error_unauthorized = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.error_unauthorized,
		"en-US": en_US.error_unauthorized,
		fr: fr.error_unauthorized,
		it: it.error_unauthorized
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const evidenceURL = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.evidenceURL,
		"en-US": en_US.evidenceURL,
		fr: fr.evidenceURL,
		it: it.evidenceURL
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const familyName = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.familyName,
		"en-US": en_US.familyName,
		fr: fr.familyName,
		it: it.familyName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const givenName = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.givenName,
		"en-US": en_US.givenName,
		fr: fr.givenName,
		it: it.givenName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const home = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.home,
		"en-US": en_US.home,
		fr: fr.home,
		it: it.home
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const identifierListLabel = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.identifierListLabel,
		"en-US": en_US.identifierListLabel,
		fr: fr.identifierListLabel,
		it: it.identifierListLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const identifierListLabel_other = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.identifierListLabel_other,
		"en-US": en_US.identifierListLabel_other,
		fr: fr.identifierListLabel_other,
		it: it.identifierListLabel_other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const image = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.image,
		"en-US": en_US.image,
		fr: fr.image,
		it: it.image
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invitation_rejectConfirm = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.invitation_rejectConfirm,
		"en-US": en_US.invitation_rejectConfirm,
		fr: fr.invitation_rejectConfirm,
		it: it.invitation_rejectConfirm
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invitation_rejectConfirm_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.invitation_rejectConfirm_description,
		"en-US": en_US.invitation_rejectConfirm_description,
		fr: fr.invitation_rejectConfirm_description,
		it: it.invitation_rejectConfirm_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ name: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const inviteJoinCTA_description = (params , options = {}) => {
	return {
		"en-AU": en_AU.inviteJoinCTA_description,
		"en-US": en_US.inviteJoinCTA_description,
		fr: fr.inviteJoinCTA_description,
		it: it.inviteJoinCTA_description
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_achievementUnauthorizedError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.invite_achievementUnauthorizedError,
		"en-US": en_US.invite_achievementUnauthorizedError,
		fr: fr.invite_achievementUnauthorizedError,
		it: it.invite_achievementUnauthorizedError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_notFoundError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.invite_notFoundError,
		"en-US": en_US.invite_notFoundError,
		fr: fr.invite_notFoundError,
		it: it.invite_notFoundError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_recipientIdentifierRequiredError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.invite_recipientIdentifierRequiredError,
		"en-US": en_US.invite_recipientIdentifierRequiredError,
		fr: fr.invite_recipientIdentifierRequiredError,
		it: it.invite_recipientIdentifierRequiredError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_unauthorizedNonAdminError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.invite_unauthorizedNonAdminError,
		"en-US": en_US.invite_unauthorizedNonAdminError,
		fr: fr.invite_unauthorizedNonAdminError,
		it: it.invite_unauthorizedNonAdminError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const linkedin_addToProfileButton_label = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.linkedin_addToProfileButton_label,
		"en-US": en_US.linkedin_addToProfileButton_label,
		fr: fr.linkedin_addToProfileButton_label,
		it: it.linkedin_addToProfileButton_label
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const logInCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.logInCTA,
		"en-US": en_US.logInCTA,
		fr: fr.logInCTA,
		it: it.logInCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const logOutCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.logOutCTA,
		"en-US": en_US.logOutCTA,
		fr: fr.logOutCTA,
		it: it.logOutCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginCTA_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.loginCTA_description,
		"en-US": en_US.loginCTA_description,
		fr: fr.loginCTA_description,
		it: it.loginCTA_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginInviteCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.loginInviteCTA,
		"en-US": en_US.loginInviteCTA,
		fr: fr.loginInviteCTA,
		it: it.loginInviteCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginInviteCTA_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.loginInviteCTA_description,
		"en-US": en_US.loginInviteCTA_description,
		fr: fr.loginInviteCTA_description,
		it: it.loginInviteCTA_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_agreeTermsError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.login_agreeTermsError,
		"en-US": en_US.login_agreeTermsError,
		fr: fr.login_agreeTermsError,
		it: it.login_agreeTermsError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_checkEmailCTA_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.login_checkEmailCTA_description,
		"en-US": en_US.login_checkEmailCTA_description,
		fr: fr.login_checkEmailCTA_description,
		it: it.login_checkEmailCTA_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_emailNotParsedError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.login_emailNotParsedError,
		"en-US": en_US.login_emailNotParsedError,
		fr: fr.login_emailNotParsedError,
		it: it.login_emailNotParsedError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ code: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_emailVerificationCodeIs = (params , options = {}) => {
	return {
		"en-AU": en_AU.login_emailVerificationCodeIs,
		"en-US": en_US.login_emailVerificationCodeIs,
		fr: fr.login_emailVerificationCodeIs,
		it: it.login_emailVerificationCodeIs
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_incorrectCodeError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.login_incorrectCodeError,
		"en-US": en_US.login_incorrectCodeError,
		fr: fr.login_incorrectCodeError,
		it: it.login_incorrectCodeError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_invitationRequiredError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.login_invitationRequiredError,
		"en-US": en_US.login_invitationRequiredError,
		fr: fr.login_invitationRequiredError,
		it: it.login_invitationRequiredError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_sendCodeCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.login_sendCodeCTA,
		"en-US": en_US.login_sendCodeCTA,
		fr: fr.login_sendCodeCTA,
		it: it.login_sendCodeCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ orgName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_toCommunityNameCTA = (params , options = {}) => {
	return {
		"en-AU": en_AU.login_toCommunityNameCTA,
		"en-US": en_US.login_toCommunityNameCTA,
		fr: fr.login_toCommunityNameCTA,
		it: it.login_toCommunityNameCTA
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_verificationCodeRequiredError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.login_verificationCodeRequiredError,
		"en-US": en_US.login_verificationCodeRequiredError,
		fr: fr.login_verificationCodeRequiredError,
		it: it.login_verificationCodeRequiredError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const markdown_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.markdown_description,
		"en-US": en_US.markdown_description,
		fr: fr.markdown_description,
		it: it.markdown_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const me = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.me,
		"en-US": en_US.me,
		fr: fr.me,
		it: it.me
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const media_localMediaOnlyAvailableInDevError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.media_localMediaOnlyAvailableInDevError,
		"en-US": en_US.media_localMediaOnlyAvailableInDevError,
		fr: fr.media_localMediaOnlyAvailableInDevError,
		it: it.media_localMediaOnlyAvailableInDevError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.member,
		"en-US": en_US.member,
		fr: fr.member,
		it: it.member
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_memberDetailsLabel = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.member_memberDetailsLabel,
		"en-US": en_US.member_memberDetailsLabel,
		fr: fr.member_memberDetailsLabel,
		it: it.member_memberDetailsLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_notFoundError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.member_notFoundError,
		"en-US": en_US.member_notFoundError,
		fr: fr.member_notFoundError,
		it: it.member_notFoundError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_other = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.member_other,
		"en-US": en_US.member_other,
		fr: fr.member_other,
		it: it.member_other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_otherUserProfileDescription = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.member_otherUserProfileDescription,
		"en-US": en_US.member_otherUserProfileDescription,
		fr: fr.member_otherUserProfileDescription,
		it: it.member_otherUserProfileDescription
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_settingsChangeUnauthenticedError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.member_settingsChangeUnauthenticedError,
		"en-US": en_US.member_settingsChangeUnauthenticedError,
		fr: fr.member_settingsChangeUnauthenticedError,
		it: it.member_settingsChangeUnauthenticedError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_share_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.member_share_description,
		"en-US": en_US.member_share_description,
		fr: fr.member_share_description,
		it: it.member_share_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_yourProfileGreeting = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.member_yourProfileGreeting,
		"en-US": en_US.member_yourProfileGreeting,
		fr: fr.member_yourProfileGreeting,
		it: it.member_yourProfileGreeting
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const members_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.members_description,
		"en-US": en_US.members_description,
		fr: fr.members_description,
		it: it.members_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const members_title = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.members_title,
		"en-US": en_US.members_title,
		fr: fr.members_title,
		it: it.members_title
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const membership = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.membership,
		"en-US": en_US.membership,
		fr: fr.membership,
		it: it.membership
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const mostAwardedAchievements = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.mostAwardedAchievements,
		"en-US": en_US.mostAwardedAchievements,
		fr: fr.mostAwardedAchievements,
		it: it.mostAwardedAchievements
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const narrative = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.narrative,
		"en-US": en_US.narrative,
		fr: fr.narrative,
		it: it.narrative
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const notFound = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.notFound,
		"en-US": en_US.notFound,
		fr: fr.notFound,
		it: it.notFound
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_editCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.org_editCTA,
		"en-US": en_US.org_editCTA,
		fr: fr.org_editCTA,
		it: it.org_editCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_edit_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.org_edit_description,
		"en-US": en_US.org_edit_description,
		fr: fr.org_edit_description,
		it: it.org_edit_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ orgName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_inviteToJoin = (params , options = {}) => {
	return {
		"en-AU": en_AU.org_inviteToJoin,
		"en-US": en_US.org_inviteToJoin,
		fr: fr.org_inviteToJoin,
		it: it.org_inviteToJoin
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ achievementName: NonNullable<unknown>, orgName: NonNullable<unknown>, inviteLink: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_inviteToJoin_description = (params , options = {}) => {
	return {
		"en-AU": en_AU.org_inviteToJoin_description,
		"en-US": en_US.org_inviteToJoin_description,
		fr: fr.org_inviteToJoin_description,
		it: it.org_inviteToJoin_description
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_name = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.org_name,
		"en-US": en_US.org_name,
		fr: fr.org_name,
		it: it.org_name
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_primaryColor = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.org_primaryColor,
		"en-US": en_US.org_primaryColor,
		fr: fr.org_primaryColor,
		it: it.org_primaryColor
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_url = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.org_url,
		"en-US": en_US.org_url,
		fr: fr.org_url,
		it: it.org_url
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_usesOrca = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.org_usesOrca,
		"en-US": en_US.org_usesOrca,
		fr: fr.org_usesOrca,
		it: it.org_usesOrca
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organization_notFoundError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.organization_notFoundError,
		"en-US": en_US.organization_notFoundError,
		fr: fr.organization_notFoundError,
		it: it.organization_notFoundError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const otherUserBadge_heading = (params , options = {}) => {
	return {
		"en-AU": en_AU.otherUserBadge_heading,
		"en-US": en_US.otherUserBadge_heading,
		fr: fr.otherUserBadge_heading,
		it: it.otherUserBadge_heading
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ page: NonNullable<unknown>, maxPage: NonNullable<unknown>, count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const paginationSummary = (params , options = {}) => {
	return {
		"en-AU": en_AU.paginationSummary,
		"en-US": en_US.paginationSummary,
		fr: fr.paginationSummary,
		it: it.paginationSummary
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const previewCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.previewCTA,
		"en-US": en_US.previewCTA,
		fr: fr.previewCTA,
		it: it.previewCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const privacyPolicy = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.privacyPolicy,
		"en-US": en_US.privacyPolicy,
		fr: fr.privacyPolicy,
		it: it.privacyPolicy
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.profile,
		"en-US": en_US.profile,
		fr: fr.profile,
		it: it.profile
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile_editCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.profile_editCTA,
		"en-US": en_US.profile_editCTA,
		fr: fr.profile_editCTA,
		it: it.profile_editCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const qrCode = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.qrCode,
		"en-US": en_US.qrCode,
		fr: fr.qrCode,
		it: it.qrCode
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_genericError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.register_genericError,
		"en-US": en_US.register_genericError,
		fr: fr.register_genericError,
		it: it.register_genericError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const requirement_statusInvalid = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.requirement_statusInvalid,
		"en-US": en_US.requirement_statusInvalid,
		fr: fr.requirement_statusInvalid,
		it: it.requirement_statusInvalid
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const saveCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.saveCTA,
		"en-US": en_US.saveCTA,
		fr: fr.saveCTA,
		it: it.saveCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const seeCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.seeCTA,
		"en-US": en_US.seeCTA,
		fr: fr.seeCTA,
		it: it.seeCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const session_invalidError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.session_invalidError,
		"en-US": en_US.session_invalidError,
		fr: fr.session_invalidError,
		it: it.session_invalidError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const setting_other = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.setting_other,
		"en-US": en_US.setting_other,
		fr: fr.setting_other,
		it: it.setting_other
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.share,
		"en-US": en_US.share,
		fr: fr.share,
		it: it.share
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_copyUrl = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.share_copyUrl,
		"en-US": en_US.share_copyUrl,
		fr: fr.share_copyUrl,
		it: it.share_copyUrl
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.share_description,
		"en-US": en_US.share_description,
		fr: fr.share_description,
		it: it.share_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCode_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.share_qrCode_description,
		"en-US": en_US.share_qrCode_description,
		fr: fr.share_qrCode_description,
		it: it.share_qrCode_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCode_heading = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.share_qrCode_heading,
		"en-US": en_US.share_qrCode_heading,
		fr: fr.share_qrCode_heading,
		it: it.share_qrCode_heading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCodeImageAltText = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.share_qrCodeImageAltText,
		"en-US": en_US.share_qrCodeImageAltText,
		fr: fr.share_qrCodeImageAltText,
		it: it.share_qrCodeImageAltText
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status,
		"en-US": en_US.status,
		fr: fr.status,
		it: it.status
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_accepted = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_accepted,
		"en-US": en_US.status_accepted,
		fr: fr.status_accepted,
		it: it.status_accepted
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_created = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_created,
		"en-US": en_US.status_created,
		fr: fr.status_created,
		it: it.status_created
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_invited,
		"en-US": en_US.status_invited,
		fr: fr.status_invited,
		it: it.status_invited
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_invited_description,
		"en-US": en_US.status_invited_description,
		fr: fr.status_invited_description,
		it: it.status_invited_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited_medium = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_invited_medium,
		"en-US": en_US.status_invited_medium,
		fr: fr.status_invited_medium,
		it: it.status_invited_medium
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_loading = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_loading,
		"en-US": en_US.status_loading,
		fr: fr.status_loading,
		it: it.status_loading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_notYetReviewed = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_notYetReviewed,
		"en-US": en_US.status_notYetReviewed,
		fr: fr.status_notYetReviewed,
		it: it.status_notYetReviewed
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ count: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_notYetReviewed_description = (params , options = {}) => {
	return {
		"en-AU": en_AU.status_notYetReviewed_description,
		"en-US": en_US.status_notYetReviewed_description,
		fr: fr.status_notYetReviewed_description,
		it: it.status_notYetReviewed_description
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_prerequisiteRequired = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_prerequisiteRequired,
		"en-US": en_US.status_prerequisiteRequired,
		fr: fr.status_prerequisiteRequired,
		it: it.status_prerequisiteRequired
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_rejected = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_rejected,
		"en-US": en_US.status_rejected,
		fr: fr.status_rejected,
		it: it.status_rejected
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_rejected_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_rejected_description,
		"en-US": en_US.status_rejected_description,
		fr: fr.status_rejected_description,
		it: it.status_rejected_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_underReview = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_underReview,
		"en-US": en_US.status_underReview,
		fr: fr.status_underReview,
		it: it.status_underReview
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_valid = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_valid,
		"en-US": en_US.status_valid,
		fr: fr.status_valid,
		it: it.status_valid
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_verified = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.status_verified,
		"en-US": en_US.status_verified,
		fr: fr.status_verified,
		it: it.status_verified
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const submitCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.submitCTA,
		"en-US": en_US.submitCTA,
		fr: fr.submitCTA,
		it: it.submitCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tagline = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.tagline,
		"en-US": en_US.tagline,
		fr: fr.tagline,
		it: it.tagline
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const termsOfService = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.termsOfService,
		"en-US": en_US.termsOfService,
		fr: fr.termsOfService,
		it: it.termsOfService
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const themeCTA_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.themeCTA_description,
		"en-US": en_US.themeCTA_description,
		fr: fr.themeCTA_description,
		it: it.themeCTA_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tos_agreementCTA_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.tos_agreementCTA_description,
		"en-US": en_US.tos_agreementCTA_description,
		fr: fr.tos_agreementCTA_description,
		it: it.tos_agreementCTA_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const unauthenticatedError = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.unauthenticatedError,
		"en-US": en_US.unauthenticatedError,
		fr: fr.unauthenticatedError,
		it: it.unauthenticatedError
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const uncategorized = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.uncategorized,
		"en-US": en_US.uncategorized,
		fr: fr.uncategorized,
		it: it.uncategorized
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const url = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.url,
		"en-US": en_US.url,
		fr: fr.url,
		it: it.url
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const verificationCode = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.verificationCode,
		"en-US": en_US.verificationCode,
		fr: fr.verificationCode,
		it: it.verificationCode
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.view,
		"en-US": en_US.view,
		fr: fr.view,
		it: it.view
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const writeCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.writeCTA,
		"en-US": en_US.writeCTA,
		fr: fr.writeCTA,
		it: it.writeCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const yourEmail = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.yourEmail,
		"en-US": en_US.yourEmail,
		fr: fr.yourEmail,
		it: it.yourEmail
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const removeCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.removeCTA,
		"en-US": en_US.removeCTA,
		fr: fr.removeCTA,
		it: it.removeCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const changeCta = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.changeCta,
		"en-US": en_US.changeCta,
		fr: fr.changeCta,
		it: it.changeCta
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_selectThisCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_selectThisCTA,
		"en-US": en_US.achievement_selectThisCTA,
		fr: fr.achievement_selectThisCTA,
		it: it.achievement_selectThisCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_searchByName = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_searchByName,
		"en-US": en_US.achievement_searchByName,
		fr: fr.achievement_searchByName,
		it: it.achievement_searchByName
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_noneFound = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievements_noneFound,
		"en-US": en_US.achievements_noneFound,
		fr: fr.achievements_noneFound,
		it: it.achievements_noneFound
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_noneFound_description = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievements_noneFound_description,
		"en-US": en_US.achievements_noneFound_description,
		fr: fr.achievements_noneFound_description,
		it: it.achievements_noneFound_description
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_errorLoading = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievements_errorLoading,
		"en-US": en_US.achievements_errorLoading,
		fr: fr.achievements_errorLoading,
		it: it.achievements_errorLoading
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_requireAReview = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievementConfig_requireAReview,
		"en-US": en_US.achievementConfig_requireAReview,
		fr: fr.achievementConfig_requireAReview,
		it: it.achievementConfig_requireAReview
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_chooseCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_chooseCTA,
		"en-US": en_US.achievement_chooseCTA,
		fr: fr.achievement_chooseCTA,
		it: it.achievement_chooseCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_anAdminReviewRequired = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_anAdminReviewRequired,
		"en-US": en_US.claimConfiguration_anAdminReviewRequired,
		fr: fr.claimConfiguration_anAdminReviewRequired,
		it: it.claimConfiguration_anAdminReviewRequired
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const inviteRequires_notFound = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.inviteRequires_notFound,
		"en-US": en_US.inviteRequires_notFound,
		fr: fr.inviteRequires_notFound,
		it: it.inviteRequires_notFound
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiredCrossValidationMessage = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievementConfig_reviewRequiredCrossValidationMessage,
		"en-US": en_US.achievementConfig_reviewRequiredCrossValidationMessage,
		fr: fr.achievementConfig_reviewRequiredCrossValidationMessage,
		it: it.achievementConfig_reviewRequiredCrossValidationMessage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardByInvitation = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievement_awardByInvitation,
		"en-US": en_US.achievement_awardByInvitation,
		fr: fr.achievement_awardByInvitation,
		it: it.achievement_awardByInvitation
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiresLabel = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievementConfig_reviewRequiresLabel,
		"en-US": en_US.achievementConfig_reviewRequiresLabel,
		fr: fr.achievementConfig_reviewRequiresLabel,
		it: it.achievementConfig_reviewRequiresLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiresLabelSpecific = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievementConfig_reviewRequiresLabelSpecific,
		"en-US": en_US.achievementConfig_reviewRequiresLabelSpecific,
		fr: fr.achievementConfig_reviewRequiresLabelSpecific,
		it: it.achievementConfig_reviewRequiresLabelSpecific
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteRequiresLabel = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievementConfig_inviteRequiresLabel,
		"en-US": en_US.achievementConfig_inviteRequiresLabel,
		fr: fr.achievementConfig_inviteRequiresLabel,
		it: it.achievementConfig_inviteRequiresLabel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_requirementHoldersOf = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievementConfig_requirementHoldersOf,
		"en-US": en_US.achievementConfig_requirementHoldersOf,
		fr: fr.achievementConfig_requirementHoldersOf,
		it: it.achievementConfig_requirementHoldersOf
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chooseCTA = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.chooseCTA,
		"en-US": en_US.chooseCTA,
		fr: fr.chooseCTA,
		it: it.chooseCTA
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_errorFetchingData = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.backpack_errorFetchingData,
		"en-US": en_US.backpack_errorFetchingData,
		fr: fr.backpack_errorFetchingData,
		it: it.backpack_errorFetchingData
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_errorFetchingData = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievements_errorFetchingData,
		"en-US": en_US.achievements_errorFetchingData,
		fr: fr.achievements_errorFetchingData,
		it: it.achievements_errorFetchingData
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_claimRequiresCrossValidationMessage = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievementConfig_claimRequiresCrossValidationMessage,
		"en-US": en_US.achievementConfig_claimRequiresCrossValidationMessage,
		fr: fr.achievementConfig_claimRequiresCrossValidationMessage,
		it: it.achievementConfig_claimRequiresCrossValidationMessage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteREquiresCrossValidationMessage = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievementConfig_inviteREquiresCrossValidationMessage,
		"en-US": en_US.achievementConfig_inviteREquiresCrossValidationMessage,
		fr: fr.achievementConfig_inviteREquiresCrossValidationMessage,
		it: it.achievementConfig_inviteREquiresCrossValidationMessage
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteRequiredGeneric = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.achievementConfig_inviteRequiredGeneric,
		"en-US": en_US.achievementConfig_inviteRequiredGeneric,
		fr: fr.achievementConfig_inviteRequiredGeneric,
		it: it.achievementConfig_inviteRequiredGeneric
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_inviteRequiresDescription = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.claimConfiguration_inviteRequiresDescription,
		"en-US": en_US.claimConfiguration_inviteRequiresDescription,
		fr: fr.claimConfiguration_inviteRequiresDescription,
		it: it.claimConfiguration_inviteRequiresDescription
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const authentication_couldNotLogIn = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.authentication_couldNotLogIn,
		"en-US": en_US.authentication_couldNotLogIn,
		fr: fr.authentication_couldNotLogIn,
		it: it.authentication_couldNotLogIn
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bad_bold_shrimp_express = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.bad_bold_shrimp_express,
		"en-US": en_US.bad_bold_shrimp_express,
		fr: fr.bad_bold_shrimp_express,
		it: it.bad_bold_shrimp_express
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tense_raw_cuckoo_dart = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.tense_raw_cuckoo_dart,
		"en-US": en_US.tense_raw_cuckoo_dart,
		fr: fr.tense_raw_cuckoo_dart,
		it: it.tense_raw_cuckoo_dart
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const known_such_scallop_gaze = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.known_such_scallop_gaze,
		"en-US": en_US.known_such_scallop_gaze,
		fr: fr.known_such_scallop_gaze,
		it: it.known_such_scallop_gaze
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const proof_funny_dog_pat = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.proof_funny_dog_pat,
		"en-US": en_US.proof_funny_dog_pat,
		fr: fr.proof_funny_dog_pat,
		it: it.proof_funny_dog_pat
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sunny_grand_lemur_race = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.sunny_grand_lemur_race,
		"en-US": en_US.sunny_grand_lemur_race,
		fr: fr.sunny_grand_lemur_race,
		it: it.sunny_grand_lemur_race
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{ achievementName: NonNullable<unknown> }} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const dull_bright_ostrich_delight = (params , options = {}) => {
	return {
		"en-AU": en_AU.dull_bright_ostrich_delight,
		"en-US": en_US.dull_bright_ostrich_delight,
		fr: fr.dull_bright_ostrich_delight,
		it: it.dull_bright_ostrich_delight
	}[options.languageTag ?? languageTag()](params)
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const merry_trite_seahorse_relish = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.merry_trite_seahorse_relish,
		"en-US": en_US.merry_trite_seahorse_relish,
		fr: fr.merry_trite_seahorse_relish,
		it: it.merry_trite_seahorse_relish
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gray_fluffy_myna_pet = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.gray_fluffy_myna_pet,
		"en-US": en_US.gray_fluffy_myna_pet,
		fr: fr.gray_fluffy_myna_pet,
		it: it.gray_fluffy_myna_pet
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const aqua_alive_cougar_tickle = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.aqua_alive_cougar_tickle,
		"en-US": en_US.aqua_alive_cougar_tickle,
		fr: fr.aqua_alive_cougar_tickle,
		it: it.aqua_alive_cougar_tickle
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const home_vivid_mole_gaze = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.home_vivid_mole_gaze,
		"en-US": en_US.home_vivid_mole_gaze,
		fr: fr.home_vivid_mole_gaze,
		it: it.home_vivid_mole_gaze
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const nice_active_giraffe_propel = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.nice_active_giraffe_propel,
		"en-US": en_US.nice_active_giraffe_propel,
		fr: fr.nice_active_giraffe_propel,
		it: it.nice_active_giraffe_propel
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const warm_male_thrush_pout = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.warm_male_thrush_pout,
		"en-US": en_US.warm_male_thrush_pout,
		fr: fr.warm_male_thrush_pout,
		it: it.warm_male_thrush_pout
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const clear_crazy_meerkat_nurture = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.clear_crazy_meerkat_nurture,
		"en-US": en_US.clear_crazy_meerkat_nurture,
		fr: fr.clear_crazy_meerkat_nurture,
		it: it.clear_crazy_meerkat_nurture
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const short_deft_lemur_clasp = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.short_deft_lemur_clasp,
		"en-US": en_US.short_deft_lemur_clasp,
		fr: fr.short_deft_lemur_clasp,
		it: it.short_deft_lemur_clasp
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const equal_small_dolphin_spur = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.equal_small_dolphin_spur,
		"en-US": en_US.equal_small_dolphin_spur,
		fr: fr.equal_small_dolphin_spur,
		it: it.equal_small_dolphin_spur
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pink_last_marten_grin = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.pink_last_marten_grin,
		"en-US": en_US.pink_last_marten_grin,
		fr: fr.pink_last_marten_grin,
		it: it.pink_last_marten_grin
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const best_sweet_termite_work = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.best_sweet_termite_work,
		"en-US": en_US.best_sweet_termite_work,
		fr: fr.best_sweet_termite_work,
		it: it.best_sweet_termite_work
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const direct_plane_boar_succeed = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.direct_plane_boar_succeed,
		"en-US": en_US.direct_plane_boar_succeed,
		fr: fr.direct_plane_boar_succeed,
		it: it.direct_plane_boar_succeed
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const every_flat_lamb_favor = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.every_flat_lamb_favor,
		"en-US": en_US.every_flat_lamb_favor,
		fr: fr.every_flat_lamb_favor,
		it: it.every_flat_lamb_favor
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const fancy_antsy_ray_gaze = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.fancy_antsy_ray_gaze,
		"en-US": en_US.fancy_antsy_ray_gaze,
		fr: fr.fancy_antsy_ray_gaze,
		it: it.fancy_antsy_ray_gaze
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tired_top_fish_bask = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.tired_top_fish_bask,
		"en-US": en_US.tired_top_fish_bask,
		fr: fr.tired_top_fish_bask,
		it: it.tired_top_fish_bask
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const factual_agent_mantis_jump = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.factual_agent_mantis_jump,
		"en-US": en_US.factual_agent_mantis_jump,
		fr: fr.factual_agent_mantis_jump,
		it: it.factual_agent_mantis_jump
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const elegant_free_cow_cherish = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.elegant_free_cow_cherish,
		"en-US": en_US.elegant_free_cow_cherish,
		fr: fr.elegant_free_cow_cherish,
		it: it.elegant_free_cow_cherish
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const grand_tangy_cheetah_buy = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.grand_tangy_cheetah_buy,
		"en-US": en_US.grand_tangy_cheetah_buy,
		fr: fr.grand_tangy_cheetah_buy,
		it: it.grand_tangy_cheetah_buy
	}[options.languageTag ?? languageTag()]()
}



/**
 * This message has been compiled by [inlang paraglide](https://inlang.com/m/gerre34r/library-inlang-paraglideJs).
 *
 * - Don't edit the message's code. Use [Sherlock (VS Code extension)](https://inlang.com/m/r7kp499g/app-inlang-ideExtension),
 *   the [web editor](https://inlang.com/m/tdozzpar/app-inlang-finkLocalizationEditor) instead, or edit the translation files manually.
 * 
 * - The params are NonNullable<unknown> because the inlang SDK does not provide information on the type of a param (yet).
 * 
 * @param {{}} params
 * @param {{ languageTag?: "en-AU" | "en-US" | "fr" | "it" }} options
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const moving_east_okapi_shrine = (params = {}, options = {}) => {
	return {
		"en-AU": en_AU.moving_east_okapi_shrine,
		"en-US": en_US.moving_east_okapi_shrine,
		fr: fr.moving_east_okapi_shrine,
		it: it.moving_east_okapi_shrine
	}[options.languageTag ?? languageTag()]()
}


